import React from 'react';
import { Dialog } from '@mui/material';
import AddStakeHolder from './AddStakeHolder';
import EditStakeHolder from './EditStakeHolder';

const StakeholderToggleModal = ({
  open,
  toggle,
  isEdit,
  getData,
  data,
  length,
  customerId,
  segmentId,
  segments,
  segmentName,
  customerName,
  setSnackBarOpen,
  setSnackbarSeverity,
  setSnackBarMessage,
}) => {
  return (
    <Dialog
      open={open}
      keepMounted
      maxWidth="md"
      fullWidth
      scroll="paper"
      onClose={toggle}
    >
      {!isEdit && (
        <AddStakeHolder
          toggle={toggle}
          open={open}
          getData={getData}
          length={length}
          customerId={customerId}
          segmentId={segmentId}
          segmentName={segmentName}
          customerName={customerName}
          setSnackBarOpen={setSnackBarOpen}
          setSnackbarSeverity={setSnackbarSeverity}
          setSnackBarMessage={setSnackBarMessage}
        />
      )}
      {isEdit && (
        <EditStakeHolder
          toggle={toggle}
          data={data}
          getData={getData}
          customerId={customerId}
          segmentId={segmentId}
          segments={segments}
          setSnackBarOpen={setSnackBarOpen}
          setSnackbarSeverity={setSnackbarSeverity}
          setSnackBarMessage={setSnackBarMessage}
        />
      )}
    </Dialog>
  );
};

export default StakeholderToggleModal;
